var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15216 5C9.15216 5.912 8.28816 6.86 6.84816 6.86H6.53616L6.77616 8.96H7.49616L7.58016 7.52C8.91216 7.448 10.1242 6.38 10.1242 5C10.1242 3.572 9.00816 2.48 7.50816 2.48C6.08016 2.48 5.43216 3.044 4.88016 3.884L5.66016 4.376C6.03216 3.776 6.58416 3.38 7.38816 3.38C8.46816 3.38 9.15216 3.968 9.15216 5ZM6.50016 10.52C6.50016 10.88 6.80016 11.18 7.16016 11.18C7.52016 11.18 7.82016 10.88 7.82016 10.52C7.82016 10.16 7.52016 9.86 7.16016 9.86C6.80016 9.86 6.50016 10.16 6.50016 10.52Z",
    fill: "#6F6F6F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.6533004ab818d5afc3dd6cbe82688dd7.svg";
export { ForwardRef as ReactComponent };